import { useState, createContext, useEffect } from "react";
import getConfig from "next/config";
import axios from "axios";

interface ILocalizationContextProps {
	locale: string;
	getTranslation: (phrase: string) => string;
}

export const LocalizationContext = createContext<ILocalizationContextProps>({
	locale: "",
	getTranslation: () => {
		return "string";
	},
});

export const LocalizationContextProvider = (props: any) => {
	const { locale, children } = props;

	const [translations, setTranslations] = useState<any>([]);
	const { publicRuntimeConfig } = getConfig();

	useEffect(() => {
		axios
			.get(
				`${process.env.NEXT_PUBLIC_LOCAL_BASE || ""}/${publicRuntimeConfig.subdir}/${
					locale ? locale : "en"
				}/decoupled-interface-translations`,
				{},
			)
			.then(res => {
				if (res.data) {
					setTranslations(res.data);
				}
			})
			.catch(e => console.log("e", e));
	}, [publicRuntimeConfig.subdir, locale]);

	const getTranslation = (phrase: string): string => {
		let traslatedPhrase;

		if (locale === "zh-cn") {
			traslatedPhrase = translations?.["zh-hant"]?.[phrase];
		} else if (locale === "zh-tw") {
			traslatedPhrase = translations?.["zh-hans"]?.[phrase];
		} else if (locale === "de") {
			traslatedPhrase = translations?.["nl"]?.[phrase];
		} else if (locale === "no") {
			traslatedPhrase = translations?.["nn"]?.[phrase];
		} else if (locale === "pt") {
			traslatedPhrase = translations?.["pt-pt"]?.[phrase];
		} else {
			traslatedPhrase = translations?.[locale]?.[phrase];
		}

		if (!traslatedPhrase) return phrase;

		return traslatedPhrase;
	};

	return (
		<LocalizationContext.Provider value={{ locale: locale || "en", getTranslation }}>
			{children}
		</LocalizationContext.Provider>
	);
};
